var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m129.403295 54.6233276v-15.692307h-5.230769v15.692307zm-.166498.8717949-2.059007 4.1180161c-.16064.3212774-.619119.3212774-.779758 0l-2.059008-4.1180161zm.166498-17.4358967v-1.7356616c0-.9742071-.777016-1.7515177-1.743733-1.7515177h-1.743302c-.961971 0-1.743734.7854488-1.743734 1.7515177v1.7356616z",
    fill: "#8c909e",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 -46.479997 -112.824203)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.89d40bde9a88b45ec254f9913e2dbe4f.svg";
export { ForwardRef as ReactComponent };